import Vue from 'vue'

import uiScroll from './src/ui-scroll.vue';

Vue.component('ui-scroll', uiScroll);

export default uiScroll;



//////////////////
// WEBPACK FOOTER
// ./~/ui-scroll/index.js
// module id = 556
// module chunks = 0